import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface ViewUserLotsProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

const formatDateForInput = (timestamp: number) => {
    if (!timestamp || isNaN(timestamp)) return '';
    try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '';

        const month = date.getMonth() + 1; // No padding with zeros
        const day = date.getDate(); // No padding with zeros
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    } catch {
        return '';
    }
};

export const ViewUserLots: FC<ViewUserLotsProps> = ({ user, onClose, show }) => {
    console.log("user", user)
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    {/* <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div> */}
                    <div className="table-responsive">
                        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "33%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Source TRN ID</th>
                                    <th style={{ width: "33%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Source Name</th>
                                    <th style={{ width: "33%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Quantity (Kg)</th>
                                    <th style={{ width: "33%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Remaining Quantity (Kg)</th>
                                    <th style={{ width: "33%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Lot Value</th>

                                </tr>
                            </thead>
                            <tbody>
                                {user?.lots?.map((lot: any, index: number) => (
                                    <tr key={index}>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>{lot?.sourceTransactionId || 'N/A'}</td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{lot?.sourceUserId || 'N/A'}</td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{lot?.quantity || 'N/A'}</td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{lot?.remainingQuantity || 'N/A'}</td>
                                        <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{lot?.purchasePrice || 'N/A'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};